import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormControlLabel, TextareaAutosize } from "@mui/material";
import {
  Button,
  Col,
  Form,
  Row,
  Stack,
  Container,
  Card,
} from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Formik } from "formik";
import { nameBasedRoutes } from "../../../router/public";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import FormHelperText from "@mui/material/FormHelperText";
import InputText from "../../../components/common/InputText";
import InputSelect from "../../../components/common/InputSelect";
import InputSelectMultiple from "../../../components/common/InputSelectMultiple";
import InputTextArea from "../../../components/common/TextArea";
import InputDatePicker from "../../../components/common/InputDatePicker";
import storage from "../../../helpers/storage";
import { getUserDetails, getMachineList } from "../../../services/userService";
import { inspectionRequest } from "../../../services/inspectionRequest";
import { getStateList } from "../../../services/authService";
import SnackbarToast from "../../../components/common/SnackBar";
import Loader from "../../../components/common/Loader";
import {
  InspectionRequestSchema,
  AddMachineSchema,
} from "../../../validations/InspectionRequest";
import plusIcon from "../../../assets/images/plus-solid.svg";
import PlusBlue from "../../../assets/images/plus-blue.svg";

import InfoIcon from "../../../assets/images/info-squar.svg";
import EditIcon from "../../../assets/images/Edit-icon.svg";
import DeleteIcon from "../../../assets/images/Delete-icon.svg";
import GooglePinIcon from "../../../assets/images/google-pin-icon.svg";
import InspectionArrow from "../../../assets/images/inspection-arrow.svg";

import { withScriptjs, withGoogleMap, Marker } from "react-google-maps";
// import GoogleMap = require('react-google-maps');
import DatePicker from "react-datepicker";
import Modal from "react-bootstrap/Modal";
import "react-datepicker/dist/react-datepicker.css";

import MatDatePicker from "../../../components/common/MatDatePicker";
import moment from "moment";
import { InspectionTypeDropDown } from "../../../constants/constants";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const center = {
  lat: 40.73061,
  lng: -73.935242,
};

// const Map = withScriptjs(
//   withGoogleMap(( onMapClick:any ) => (
//     <GoogleMap defaultZoom={8} defaultCenter={{ lat: 40.712776, lng: -74.005974 }} onClick={onMapClick}>
//       <Marker position={{ lat: 40.712776, lng: -74.005974 }} />
//     </GoogleMap>
//   ))
// );

export const FieldSheet = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [googleFields, setGoogleFields] = useState(true);
  const ref = useRef<any>();
  const buttonRef = useRef<any>(null);
  const [jobState, setJobState] = useState("");
  const [showSnackBar, setshowSnackBar]: any = useState({
    show: false,
    message: "",
    severity: "",
  });
  const handleClose = () => {
    setshowSnackBar({
      show: false,
      message: "",
      severity: "",
    });
  };
  const [show, setShow] = useState(false);
  const handleModalClose = () => setShow(false);
  const [formFieldValue, setFormFieldValue] = useState<any>([]);
  let setFormFieldValues: any[];
  const [noMachine, setNoMachine] = useState<number>();
  const handleShow = (setFieldValue: any) => {
    setFormFieldValues = setFieldValue;
    setNoMachine(5);
    setShow(true);
    setFormFieldValue(setFieldValue);
  };
  let initialValues = {
    project_name: "",
    no_machine: "",
    job_contact: "",
    company_name: "",
    po_no: "",
    ordered_by: "",
    inspection_datetime: "",
    machine_inspect: [],
    job_location: "",
    job_location_address: "",
    job_location_city: "",
    job_location_state: "",
    job_location_zip_code: "",
    job_location_comment: "",

    decal_name: "",
    decal_email: "",
    decal_address: "",
    decal_city: "",
    decal_state: "",
    decal_zip_code: "",

    Status: false,
  };

  const initialValuesMachine = {
    device_id: "",
    make: "",
    model_no: "",
    serial_no: "",
    inspection_type: "",
  };
  const [states, setStates] = useState([]);
  const [machines, setMachines] = useState<any>([]);
  const [machineList, setMachineList] = useState<any>([]);

  const [userData, setuserData] = useState<any>({
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    createdAt: "",
    updatedAt: "",
    role: "",
    decalContact: {
      name: null,
      email: "",
      cell_number: "",
      address: "",
      state_id: null,
      city: "",
      zip_code: "",
      state: {
        title: "",
        code: "",
      },
    },
  });
  const userInformation: any = storage.getData("user-info");
  const [machineData, setMachineData] = useState<any>([]);
  const [mainFormActions, setMainFormActions] = useState<any>([]);

  const userId = userInformation.id;
  let isMachine = false;
  let isUserData = false;
  let isStates = false;
  const [hideShowMachineDropdown, setHideShowMachineDropdown] = useState(true);
  const [hideShowNoMachine, setHideShowNoMachine] = useState(true);

  useEffect(() => {
    if (storage.getToken() != null) {
      // getMachineListData();
      getUserData();
      // setLoading(false);
    }
  }, []);

  const getMachineListData = async () => {
    await getMachineList({ userId })
      .then((response) => {
        setMachines(response.data);
        const newData = machines.map((obj: any) => ({
          key: obj.id,
          value:
            obj.make +
            "(" +
            obj.device_id +
            "/" +
            obj.model_number +
            "/" +
            obj.serial_number +
            ")",
        }));

        setMachineList(newData);
      })
      .catch((error) => {
        setshowSnackBar({
          show: true,
          message: error.response.data.message,
          severity: "error",
        });
      });
  };

  let newData: any[] = [];
  const getUserData = async () => {
    await getMachineList({ userId })
      .then(async (response) => {
        
        setMachines(response.data);

        const newData = await Promise.all(
          response.data.map(async (obj: any) => {
            
            const manipulatedValue = await manipulateValue(obj);
            return { key: obj.id, value: manipulatedValue };
          })
        );
        // machineList.push(...newData);
        setMachineList(newData);

        await getUserDetails({ userId })
          .then((response) => {
            setuserData(response.data);
            getStateList()
              .then((response) => {
                setStates(response.data);
                setLoading(false);
              })
              .catch((error) => {
                setshowSnackBar({
                  show: true,
                  message: error.response.data.message,
                  severity: "error",
                });
              });
          })
          .catch((error) => {
            setLoading(false);
          });
      })
      .catch((error) => {
        setshowSnackBar({
          show: true,
          message: error.response.data.message,
          severity: "error",
        });
      });

    // await getStateList().then(response => {
    //     setLoading(true);
    //     setStates(response.data);
    //     isStates = true;
    //     updateLoader();
    //     setLoading(false);
    // }).catch(error => {
    //     setshowSnackBar({
    //         show: true,
    //         message: error.response.data.message,
    //         severity: 'error'
    //     });
    // })

    // await getMachineList({ userId }).then(response => {
    //     setLoading(true);
    //     setMachines(response.data);
    //     const newData = machines.map((obj:any) => ({
    //       key: obj.id,
    //       value: obj.make + '(' + obj.device_id +'/'+obj.model_number+'/'+obj.serial_number+')'
    //     }));
    //     setMachineList(newData);
    //     isMachine = true;
    //     // hideShowMachineDropdownFun();
    //     updateLoader();
    //     setLoading(false);
    // }).catch(error => {
    //     setshowSnackBar({
    //         show: true,
    //         message: error.response.data.message,
    //         severity: 'error'
    //     });
    // })
  };

  const manipulateValue = (obj: any) => {
    return (
      obj.make +
      "(" +
      obj.device_id +
      "/" +
      obj.model_number +
      "/" +
      obj.serial_number +
      ")"
    );
  };

  // const hideShowMachineDropdownFun = async () => {
  //     setLoading(true);
  //     await Promise.resolve();
  //     setLoading(false);
  // }

  const updateLoader = () => {
    if (isUserData && isMachine && isStates) {
      setLoading(false);
    }
  };
  const [plusCount, setPlusCount] = useState(0);
  const addSelectedMachine = async (
    ids: any,
    setFieldValue: any,
    no_machine: any
  ) => {
    

    ids.forEach((id: any) => {
      
      let checkAlreadyAdded = machineData.filter((item: any) => item.id === id);

      if (checkAlreadyAdded.length > 0) {
        setshowSnackBar({
          show: true,
          message: "Machine Already added.",
          severity: "error",
        });
        return false;
      }

      if (id) {
        let machine = machines.filter((item: any) => item.id === id);
        let newData = {
          id: machine[0].id,
          device_id: machine[0].device_id,
          make: machine[0].make,
          model_no: machine[0].model_number,
          serial_no: machine[0].serial_number,
          inspection_type: machine[0].inspection_type,
        };

        setMachineData((prev: any) => [...prev, newData]);
        buttonRef.current.click();
      }
    });
  };

  const addData = () => {
    const newData = {
      id: 4,
      device_id: "new data",
      make: 235,
      model_no: 253,
      serial_no: 255,
      inspection_type: 256,
    };
    setMachineData((prev: any) => [...prev, newData]);
  };

  const deleteMachine = (idx: any) => {
    // let newData = machineData.filter((item:any) => item.id !== id);
    // setMachineData(newData);

    let newData = [...machineData];
    newData.splice(idx, 1);
    setMachineData(newData);
  };
  const [inspectionDatetime, setInspectionDatetime] = useState<any>(null);
  const handleSubmit = async (values: any, actions: any) => {
    if (inspectionDatetime !== null) {
      let inspectionDate =
        moment(inspectionDatetime).format("YYYY/MM/DD H:mm:ss");
      let inspectionTime = moment(inspectionDatetime).format("H:mm:ss");
      // return true;
      let formData = {
        // company_name:values.company_name,
        inspection_date: inspectionDate,
        inspection_date_time: inspectionDate,
        inspection_time: inspectionTime,
        job_contact: values.job_contact,
        // job_location:values.job_location,
        job_location_address: values.job_location_address,
        job_location_city: values.job_location_city,
        job_location_comment: values.job_location_comment,
        job_location_state: values.job_location_state,
        job_location_zip_code: values.job_location_zip_code,
        // machine_inspect:values.machine_inspect,
        // no_machine:values.no_machine,
        ordered_by: values.ordered_by,
        po_no: values.po_no,
        project_name: values.project_name,
        machineData: machineData,
        user_id: userId,
      };

      inspectionRequest(formData)
        .then((response) => {
          setLoading(false);
          setshowSnackBar({
            show: true,
            message: response.data.message,
            severity: "success",
          });
          setTimeout(() => {
            navigate(nameBasedProtectedRoutes.dashborad.path);
          }, 1000);
        })
        .catch((error) => {
          setLoading(false);
          
          setshowSnackBar({
            show: true,
            message: error.response.data.message,
            severity: "error",
          });
        });
    } else {
      
      setshowSnackBar({
        show: true,
        message: "Date & Time field is required.",
        severity: "error",
      });
      // actions.setFieldError("inspection_datetime","Date & Time field is required.");
    }
  };

  const handleMapClick = (event: google.maps.MapMouseEvent) => {
    // console.log(event.latLng.lat(), event.latLng.lng());
  };

  const addMachineSubmitForm = async (values: any, actions: any) => {
    
    const newData = {
      id: "",
      device_id: values.device_id,
      make: values.make,
      model_no: values.model_no,
      serial_no: values.serial_no,
      inspection_type: values.inspection_type,
    };
    setMachineData((prev: any) => [...prev, newData]);
    handleModalClose();
    buttonRef.current.click();
  };
  const [googleAddress, setGoogleAddress] = useState<any>(null);
  const [markerPosition, setMarkerPosition] = useState<any>(null);
  const [stateGoogle, setStateGoogle] = useState<any>(null);
  const handleReverse = (googleAddress: any, markerPosition: any) => {
    setGoogleAddress(googleAddress);
    setMarkerPosition(markerPosition);
    let stateGoogle: any = states.filter((item: any) => {
      return item.value.toLowerCase() == googleAddress.state.toLowerCase();
    });
    if (stateGoogle.length > 0) {
      setStateGoogle(stateGoogle[0].key);
    } else {
      setStateGoogle("");
    }
  };

  const assignAddress = async (values: any, setFieldValue: any) => {
    setFieldValue("job_location_address", googleAddress.address);
    setFieldValue("job_location_city", googleAddress.city);
    setFieldValue("job_location_state", stateGoogle);
    setFieldValue("job_location_zip_code", googleAddress.zipcode);
    hideShowGoogleFields(false);
    await Promise.resolve();
    hideShowGoogleFields(true);
  };

  const hideShowGoogleFields = (status: any) => {
    setGoogleFields(status);
  };

  setTimeout(() => {
    buttonRef.current.click();
  }, 1000);
  const updateNoMachine = async (values: any, setFieldValue: any) => {
    const totalMachine = machineData.length;
    const oldValue = !isNaN(values.no_machine) ? values.no_machine : 0;
    if (oldValue < totalMachine) {
      setFieldValue("no_machine", totalMachine);
      setHideShowNoMachine(false);
      await Promise.resolve();
      setHideShowNoMachine(true);
    }
  };

  return (
    <section className="profile-main pt-4 inspector-bg ">
      <Container className="">
        <Row>
          <Col md={12} lg={12}>
            <h1 className="fs-16  mb-3 mt-2">
              <img src={InspectionArrow} className="inspection-arrow" />
              <span className="fw-bold">Inspection for SR:</span> 2212302 Model
              no.:<span className="fw-bold"> MLC150-1</span>
            </h1>
          </Col>
        </Row>
      </Container>
      {/* Content */}
      <div className="">
        <div className="">
          {!loading ? (
            <Formik
              validationSchema={InspectionRequestSchema}
              enableReinitialize={true}
              initialValues={initialValues}
              // ref={ref}
              onSubmit={handleSubmit}
              // onSubmit={(values, actions) => {
              //     actions.setSubmitting(false);
              //     submitForm()
              // }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
                setFieldValue,
                setFieldError,
                setValues,
              }) => (
                <Form className="" noValidate onSubmit={handleSubmit}>
                  <Container className="">
                    <button
                      onClick={() => updateNoMachine(values, setFieldValue)}
                      type="button"
                      ref={buttonRef}
                      className="d-none"
                    >
                      Click me
                    </button>
                    <Row>
                      <Col md={12} lg={12} className="inspector-tab-p-0">
                        <Card className="border-0 mb-3">
                          <Card.Body className="br-10 p-4">
                            <div className="col-xl-12">
                              <Tabs
                                defaultActiveKey="General"
                                id="justify-tab-example"
                                className="mb-5 field-sheet-tab"
                                justify
                              >
                                <Tab eventKey="General" title="General">
                                  <Row>
                                    <Col md="12">
                                      <h2 className="fs-16 fw-bold border-left-6 mb-4 text-uppercase">
                                        GENERAL
                                      </h2>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col
                                      md="6"
                                      className="inspector-start-date inspector-date-icon"
                                    >
                                      <InputSelect
                                        controlId="job_location_state"
                                        label="Worksite changes"
                                        placeholder="Worksite changes"
                                        touched={touched.job_location_state}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={errors.job_location_state}
                                        value={values.job_location_state}
                                        options={states}
                                      />
                                      Capacity chart
                                    </Col>
                                    <Col md="6">
                                      <InputSelect
                                        controlId="job_location_state"
                                        label="Worksite changes"
                                        placeholder="Worksite changes"
                                        touched={touched.job_location_state}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={errors.job_location_state}
                                        value={values.job_location_state}
                                        options={states}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md="6">
                                      <InputText
                                        controlId="job_contact"
                                        label="Job location"
                                        placeholder="Job location"
                                        touched={touched.job_contact}
                                        handleBlur={handleBlur}
                                        handleChange={handleChange}
                                        errorsField={errors.job_contact}
                                        value={values.job_contact}
                                      />
                                    </Col>
                                  </Row>
                                </Tab>
                                <Tab eventKey="Machinery" title="Machinery">
                                  Machinery
                                </Tab>
                                <Tab eventKey="Attachments" title="Attachments">
                                  Attachments
                                </Tab>
                                <Tab eventKey="Wire-Rope" title="Wire Rope">
                                  Wire Rope
                                </Tab>
                                <Tab eventKey="Tackle" title="Tackle">
                                  Tackle
                                </Tab>
                                <Tab eventKey="Load-Test" title="Load Test">
                                  Load Test
                                </Tab>
                                <Tab eventKey="Notes" title="Notes﻿">
                                  Notes
                                </Tab>
                              </Tabs>
                            </div>

                            {/*Decal Information*/}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Container>

                  <div className="d-flex justify-content-end inspector-footer pt-3 pb-3 pe-3 ps-3">
                    <Container>
                      <Row>
                        <Col sm="12" className="d-flex justify-content-between">
                          <Button
                            type="button"
                            variant="outline-secondary"
                            className="btn fw-semibold fs-14"
                          >
                            Back
                          </Button>
                          <Button
                            type="submit"
                            variant="primary"
                            className="btn btn-primary fw-semibold fs-14"
                          >
                            Next
                          </Button>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Form>
              )}
            </Formik>
          ) : (
            ""
          )}
        </div>
      </div>

      {/*Add new machine*/}
      <Modal
        show={show}
        onHide={handleModalClose}
        centered
        dialogClassName="modal-350w"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-25 fw-bold">New Machine</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={AddMachineSchema}
            initialValues={initialValuesMachine}
            onSubmit={(values, actions) => {
              actions.setSubmitting(false);
              addMachineSubmitForm(values, actions);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <Form className="text-start" noValidate onSubmit={handleSubmit}>
                <InputText
                  controlId="device_id"
                  label="Device ID"
                  placeholder="Device ID"
                  touched={touched.device_id}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.device_id}
                  value={values.device_id}
                />
                <InputText
                  controlId="make"
                  label="Make"
                  placeholder="Make"
                  touched={touched.make}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.make}
                  value={values.make}
                />
                <InputText
                  controlId="model_no"
                  label="Model no."
                  placeholder="Model no."
                  touched={touched.model_no}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.model_no}
                  value={values.model_no}
                />
                <InputText
                  controlId="serial_no"
                  label="Serial no."
                  placeholder="Serial no."
                  touched={touched.serial_no}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.serial_no}
                  value={values.serial_no}
                />
                <InputSelect
                  controlId="inspection_type"
                  label="Inspection Type"
                  placeholder="Inspection Type"
                  touched={touched.inspection_type}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.inspection_type}
                  value={values.inspection_type}
                  options={InspectionTypeDropDown}
                />

                <div className="d-flex justify-content-end">
                  <Button
                    variant="outline-secondary"
                    className="me-2 fs-15 fw-semibold text-black"
                    onClick={handleModalClose}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    className="fs-15 fw-semibold text-black"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <SnackbarToast showSnackBar={showSnackBar} handleClose={handleClose} />
      <Loader isLoading={loading} />
    </section>
  );
};
